import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { ICONS } from '@ohif/ui';
import moment from 'moment';

export const getCurrencySymbol = (currency) => {
  switch (currency) {
      case "INR":
          return "₹";
      case "USD":
          return "$";
      case "AED":
          return "AED ";
      case "EUR":
          return "€";
      default:
          return "";
  }
};

export const getCurrencyContact = (currency) => {
  switch (currency) {
      case "INR":
          return "+91";
      case "USD":
          return "+1";
      case "AED":
          return "+971";
      default:
          return "+91";
  }
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const formatTimeFromMinutes = (totalMinutes: number) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

export const capitalizeWords = (str) =>
  str
      ? str
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      : '';

export const calculateAge = (dob: string | null | undefined): string | null => {
  if (!dob) return null;

  const birthDate = new Date(dob);
  if (isNaN(birthDate.getTime())) return null;

  const today = new Date();

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  let days = today.getDate() - birthDate.getDate();

  if (days < 0) {
    months--;
    const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += lastMonth.getDate();
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  let ageString = '';

  if (years > 0) {
    ageString += `${years} `;
  }

  if (months > 0) {
    ageString += `${months} Month${months > 1 ? 's' : ''} `;
  }

  if (years === 0 && months === 0 && days > 0) {
    ageString += `${days} Day${days > 1 ? 's' : ''} `;
  }

  if (ageString.trim() === '') {
    return '0 day';
  }

  return ageString.trim();
};

export const formatDate = (date, type?) => {
  if (type) {
    return moment(date).format('DD-MM-YYYY, hh:mm A');
  }
  else {
    return moment(date).format('DD-MM-YYYY');
  }
}

export const formattedDate = (date, type?) => {
  if (!date) return null;

  const parsedDate = moment(date, 'DD-MM-YYYY');

  if (!parsedDate.isValid()) {
    return null;
  }

  if (type) {
    return parsedDate.format('YYYY-MM-DD hh:mm A');
  } else {
    return parsedDate.format('YYYY-MM-DD');
  }
};

export const formatCustomerType = (type) => {
  return type.replace(/([A-Z])/g, ' $1').trim();
};

export const formatTime = (time,type?) => {
  if(type){
    return  moment(time, 'HH:mm').format('hh:mm A');
  }
  else{
    const formattedTime = moment(time).format("hh:mm A");
    return formattedTime
  }

}
export const formatDays = (days: string[]): string => {
  const fullWeek: string[] = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const sortedDays = [...days].sort(
    (a, b) => fullWeek.indexOf(a) - fullWeek.indexOf(b)
  );

  if (sortedDays.length === 1) {
    return sortedDays[0];
  }

    const allExceptLast = sortedDays.slice(0, -1);
    const last = sortedDays[sortedDays.length - 1];
    return `${allExceptLast.join(", ")} & ${last}`;
};

export const customStyle = {
  select: {
    background: `#F6FFFF url(${ICONS.selectDropDownIcon}) right 1rem center no-repeat`,
  },
  calendar: {
    background: `#F6FFFF url(${ICONS.calendarSelectIcon}) right 1rem center no-repeat`
  },
  time: {
    background: `#F6FFFF url(${ICONS.timeIcon}) right 1rem center no-repeat`
  },
  checkbox: {
    background: `#F6FFFF url(${ICONS.checkBoxIcon}) no-repeat`
  },
  mainBackground: {
    background: `url(${ICONS.backgroundImage}) no-repeat`,
    backgroundSize:'100% 100%',
    backgroundPosition:"center center",
  }
}

export const formatTimeToAMPM = (updatedTime: string): string => {
  if (!updatedTime) return "";

  try {
    if (!/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(updatedTime)) {
      throw new Error("Invalid time format");
    }
    const [hours24, minutes] = updatedTime.split(':');
    const hoursNum = parseInt(hours24);
    if (hoursNum < 0 || hoursNum > 23) {
      throw new Error("Hours must be between 0 and 23");
    }
    const period = hoursNum >= 12 ? 'PM' : 'AM';
    const hours12 = hoursNum % 12 || 12;
    const paddedMinutes = minutes.padStart(2, '0');
    return `${hours12.toString().padStart(2, '0')}:${paddedMinutes} ${period}`;
  } catch (error) {
    console.error('Error formatting time:', error);
    return "";
  }
}

export const convertKBtoGB = (kb:number,roundedUpto:number) => {
  const gb = kb / (1024 * 1024);
  return parseFloat(gb.toFixed(roundedUpto));
}

export const calculateDaysLeft = (dateStr) => {
    const expiry = new Date(dateStr);
    const today = new Date();

    // Reset time to midnight for accurate day difference
    expiry.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
  // @ts-ignore
    const diffInMs:any = expiry - today;
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

    return diffInDays;
};
